/**
 * Optional DeskReplay add-on modules.
 * USD list prices; INR uses the same ~100 INR per USD ratio as CCTV+ tiers in planCatalog
 * (e.g. $10/mo → ₹1,000/mo).
 */

export type ModuleTierId =
  | "audio-pro"
  | "audio-enterprise"
  | "webcam-pro"
  | "webcam-enterprise"
  | "cctv-pro"
  | "cctv-enterprise";

export interface ModuleSku {
  id: ModuleTierId;
  headline: string;
  listUsdPerMonth: number;
  listInrPerMonth: number;
  unitLabel: string;
  requiresEndpointPool: "pro_plus" | "enterprise";
  summary: string;
}

export const MODULE_ADDON_SECTION_LABEL = "Optional add-on · purchased separately";

export const MODULE_SKUS: ModuleSku[] = [
  {
    id: "audio-pro",
    headline: "Session Audio Pro",
    listUsdPerMonth: 5,
    listInrPerMonth: 500,
    unitLabel: "per seat / month",
    requiresEndpointPool: "pro_plus",
    summary: "System audio streaming (PC speaker output) muxed into session segments when enabled by policy.",
  },
  {
    id: "audio-enterprise",
    headline: "Session Audio Enterprise",
    listUsdPerMonth: 8,
    listInrPerMonth: 800,
    unitLabel: "per seat / month",
    requiresEndpointPool: "enterprise",
    summary: "Everything in Session Audio Pro, plus microphone streaming profiles (stereo split or mixed mono).",
  },
  {
    id: "webcam-pro",
    headline: "Webcam Capture Pro",
    listUsdPerMonth: 10,
    listInrPerMonth: 1000,
    unitLabel: "per seat / month",
    requiresEndpointPool: "pro_plus",
    summary: "Fixed and random interval identity snapshots at Standard quality (Low/Medium profile settings).",
  },
  {
    id: "webcam-enterprise",
    headline: "Webcam Capture Enterprise",
    listUsdPerMonth: 15,
    listInrPerMonth: 1500,
    unitLabel: "per seat / month",
    requiresEndpointPool: "enterprise",
    summary: "Pro schedules plus app trigger and system startup capture, with Best quality (hardware-dependent).",
  },
];

export function moduleSkusForKind(kind: "audio" | "webcam"): ModuleSku[] {
  return MODULE_SKUS.filter((s) => s.id.startsWith(kind));
}
